module.exports = __webpack_public_path__ + "static/water_glacier9-859a5d8a0ba32fd9dd781e3aea864688.jpg";